/** Treehouse `TreehouseRedemptionV2` — the queued exit.
 *
 *  `getPendingRedeems(user)` returns the user's whole open-request array;
 *  claimed entries are removed with swap-and-pop, so the array position IS
 *  the claim argument and it is not stable across claims.
 *
 *  `RedemptionInfo.assets` is `previewRedeem(shares)` captured at REQUEST
 *  time. It is not the payout: `finalizeRedeem` settles at
 *  `min(rate_at_request, rate_at_finalize)` scaled by the wstETH/stETH
 *  ratio move and then takes `redemptionFee`, and the contract asserts the
 *  result never exceeds `assets`. Treat it as a ceiling. */
export const TreehouseRedemptionQueueAbi = [
  {
    name: 'getPendingRedeems',
    type: 'function',
    stateMutability: 'view',
    inputs: [{ type: 'address', name: 'user' }],
    outputs: [
      {
        type: 'tuple[]',
        components: [
          { type: 'uint64', name: 'startTime' },
          { type: 'uint96', name: 'shares' },
          { type: 'uint128', name: 'assets' },
          { type: 'uint128', name: 'baseRate' },
        ],
      },
    ],
  },
  {
    name: 'waitingPeriod',
    type: 'function',
    stateMutability: 'view',
    inputs: [],
    outputs: [{ type: 'uint32' }],
  },
] as const
